import { ListScaffold, type ListRow } from "@/components/ListScaffold";

// Binders (presentational scaffolding). Mirrors the Submissions tab; not wired.
const ROWS: ListRow[] = [
  {
    id: "BND-3007",
    account: "Acme Builders LLC",
    coverage: "General Liability",
    date: "2026-03-01",
    status: "bound",
    carrier: "Travelers",
  },
  {
    id: "BND-3008",
    account: "Ironwood Construction",
    coverage: "Workers Compensation",
    date: "2026-02-15",
    status: "bound",
    carrier: "Pie",
  },
  {
    id: "BND-3009",
    account: "Summit Point Contractors",
    coverage: "Commercial Auto",
    date: "2026-03-10",
    status: "bound",
    carrier: "Progressive",
  },
];

export function BindersPage() {
  return (
    <ListScaffold
      title="Binders"
      subtitle="Coverage bound and awaiting policy issuance."
      idLabel="Binder"
      dateLabel="Effective"
      noun="binders"
      rows={ROWS}
    />
  );
}
